import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {toast} from 'react-toastify';
import {QUERY_KEYS} from '../../utils/queryKeys';
import i18n from '../../i18n';
import {IPresentation, IPresentationMeta} from '../../incase-domain/presentation';
import {updatePresentation} from '../../service/presentation';
import {IUpdateError} from '../../store/actions/types/error.types';

export function usePresentationFavorite(): UseMutationResult<
    IPresentationMeta & {
        errors: Record<string, string[]>;
    },
    IUpdateError,
    IPresentation
> {
    const client = useQueryClient();

    return useMutation(
        (presentation) =>
            updatePresentation({
                ...presentation,
                favorite: !presentation.favorite,
            }),
        {
            onSuccess: (presentation) => {
                client.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
                if (presentation.favorite) {
                    toast.success(`${presentation.name} ${i18n.t('editorPage.favoritePresentation.mark')}`);
                }
                if (!presentation.favorite) {
                    toast.success(`${i18n.t('editorPage.favoritePresentation.unmark')} ${presentation.name}`);
                }
            },
            onError: () => {
                toast.error(`${i18n.t('editorPage.favoritePresentation.markError')}`);
            },
        }
    );
}
